var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7069 0.416169C13.8944 0.603697 13.9997 0.858005 13.9997 1.12317C13.9997 1.38833 13.8944 1.64264 13.7069 1.83017L5.70692 9.83017C5.51939 10.0176 5.26508 10.123 4.99992 10.123C4.73475 10.123 4.48045 10.0176 4.29292 9.83017L0.292919 5.83017C0.110761 5.64157 0.00996641 5.38896 0.0122448 5.12677C0.0145233 4.86457 0.119692 4.61376 0.3051 4.42835C0.490508 4.24294 0.741321 4.13777 1.00352 4.1355C1.26571 4.13322 1.51832 4.23401 1.70692 4.41617L4.99992 7.70917L12.2929 0.416169C12.4804 0.228698 12.7348 0.123383 12.9999 0.123383C13.2651 0.123383 13.5194 0.228698 13.7069 0.416169Z",
    fill: "#032250"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck2);
export default __webpack_public_path__ + "static/media/check2.6a5fb8bd6f774ad9b7e513a84f73d3ce.svg";
export { ForwardRef as ReactComponent };